'use client';
import Image from 'next/image';
import closeIcon from '@images/ico-banner-close.svg';
import { TRACKED_EVENT_POSITION } from '@/constants';
import { TrackedButton } from '@/components/button/tracked-button';
import { useBanner } from './banner-provider.context';
import { BANNER_HOOK } from './banner-eligibility';

export default function BannerHiddenButton({ label }: { label: string }) {
  const { hideBanner } = useBanner();

  return (
    <TrackedButton
      type="button"
      label="banner_btn-close"
      position={TRACKED_EVENT_POSITION.BANNER}
      title={label}
      aria-label={label}
      onClick={() => hideBanner()}
      className="flex items-center"
      {...{ [BANNER_HOOK.CLOSE]: '' }}
    >
      <Image
        src={closeIcon}
        alt={label}
        priority
        className="size-[22px] md:size-6"
      />
    </TrackedButton>
  );
}
